/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PatternString } from "@pagopa/ts-commons/lib/strings";
import * as t from "io-ts";

export type RptId = t.TypeOf<typeof RptId>;
export const RptId = PatternString(
  "([a-zA-Z0-9]{1,35})|(RFd{2}[a-zA-Z0-9]{1,21})"
);
